import { Component, OnInit } from '@angular/core';
import { DynamicForm } from 'dynamic-forms-lib';
import { TipoEstablecimientoPostRegistro } from '../../../../models/tipo-establecimiento.post-registro.model';
import { CatalogosService } from '../../../../services/catalogos.service';

@Component({
  templateUrl: './post-registro-establecimientos.component.html',
  styleUrls: ['./post-registro-establecimientos.component.css'],
})
export class PostRegistroEstablecimientosComponent implements OnInit {
  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio',
    },
    {
      label: 'Modificación de Establecimientos',
      routerLink: '/post-registro/establecimientos',
    },
  ];


  tipos: TipoEstablecimientoPostRegistro[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {}

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposEstablecimientosPR().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }
}
